import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StyledDivider = _styled("div", {
  target: "e15ojzfu0"
})("height:", function (props) {
  return !props.vertical && '2px';
}, ";width:", function (props) {
  return props.vertical && '2px';
}, ";background:", function (props) {
  return props.light ? theme.colors.shade80 : theme.colors.shade10;
}, ";opacity:", function (props) {
  return props.light ? '0.08' : '0.2';
}, ";border-radius:1px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RpdmlkZXIvRGl2aWRlci5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTWdDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RpdmlkZXIvRGl2aWRlci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcblxuaW1wb3J0IHsgZWxvIGFzIHRoZW1lIH0gZnJvbSAnLi4vLi4vdGhlbWVzJ1xuXG5jb25zdCBTdHlsZWREaXZpZGVyID0gc3R5bGVkLmRpdmBcbiAgaGVpZ2h0OiAke3Byb3BzID0+ICFwcm9wcy52ZXJ0aWNhbCAmJiAnMnB4J307XG4gIHdpZHRoOiAke3Byb3BzID0+IHByb3BzLnZlcnRpY2FsICYmICcycHgnfTtcbiAgYmFja2dyb3VuZDogJHtwcm9wcyA9PlxuICAgIHByb3BzLmxpZ2h0ID8gdGhlbWUuY29sb3JzLnNoYWRlODAgOiB0aGVtZS5jb2xvcnMuc2hhZGUxMH07XG4gIG9wYWNpdHk6ICR7cHJvcHMgPT4gKHByb3BzLmxpZ2h0ID8gJzAuMDgnIDogJzAuMicpfTtcbiAgYm9yZGVyLXJhZGl1czogMXB4O1xuYFxuXG5jb25zdCBEaXZpZGVyID0gcHJvcHMgPT4gPFN0eWxlZERpdmlkZXIgey4uLnByb3BzfSAvPlxuXG5EaXZpZGVyLnByb3BUeXBlcyA9IHtcbiAgbGlnaHQ6IFByb3BUeXBlcy5ib29sLFxuICB2ZXJ0aWNhbDogUHJvcFR5cGVzLmJvb2wsXG59XG5cbmV4cG9ydCBkZWZhdWx0IERpdmlkZXJcbiJdfQ== */"));
var Divider = function Divider(props) {
  return ___EmotionJSX(StyledDivider, props);
};
Divider.propTypes = {
  light: PropTypes.bool,
  vertical: PropTypes.bool
};
export default Divider;